import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrSetFileCategoryStatusPayload } from 'api/actions/hr-set-file-category-status/hr-set-file-category-status-payload';
import { HrSetFileCategoryStatusPathParameters } from 'api/actions/hr-set-file-category-status/hr-set-file-category-status-path-parameters';
import { HrSetFileCategoryStatusResponse } from 'api/actions/hr-set-file-category-status/hr-set-file-category-status-response';

type HrSetFileCategoryStatusQueryParameters = Record<string, any>;

/**
 * The path of the HrSetFileCategoryStatus action.
 */
export const hrSetFileCategoryStatusActionPath = new SweetPath<keyof HrSetFileCategoryStatusPathParameters>(
  '/api/hr/file-categories/{categoryId}/status',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrSetFileCategoryStatus actions.
 */
export default function createHrSetFileCategoryStatusAction(axios: AxiosInstance) {
  return function hrSetFileCategoryStatusAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrSetFileCategoryStatusPathParameters;
    query?: HrSetFileCategoryStatusQueryParameters;
    payload: HrSetFileCategoryStatusPayload;
  }) {
    const path = hrSetFileCategoryStatusActionPath.insert(parameters);

    return axios.request<HrSetFileCategoryStatusResponse, HrSetFileCategoryStatusResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
